module.exports = __webpack_public_path__ + "img/A58-20190408_01.ac5f66d8.jpg";